import initialState from '../store/initialState'
import usersTypes from '../constants/usersTypes'

const { M } = window
const { toast } = M

export default function usersReducer(state = initialState.users, action) {
  switch (action.type) {

    case usersTypes.reset_errors: {
      return {
        ...state,
        errors: []
      }
    }

    // INDEX
    case usersTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case usersTypes.index.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.users,
        pagination: action.payload.pagination,
        errors: []
      }
    }

    case usersTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // LOCK = DISABLE, UNLOCK = ENABLE
    case usersTypes.lock.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case usersTypes.lock.success: {
      const {user}=action.payload
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        must_redirect: false,
        items: state.items.map( item => {
          if (item.id === user.id) {
            return user
          } else {
            return item
          }
        })
      }
    }

    case usersTypes.lock.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // DELETE
    case usersTypes.destroy.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case usersTypes.destroy.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        items: action.payload.users,
        pagination: action.payload.pagination
      }
    }

    case usersTypes.destroy.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case usersTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case usersTypes.update.success: {
      const {user}=action.payload
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        items: state.items.map( item => {
          if (item.id === user.id) {
            if (JSON.stringify(user) === JSON.stringify(item)) {
              toast({
                html: "No change!"
              })
              return item
            } else {
              return user
            }
          } else {
            return item
          }
        })
      }
    }

    case usersTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CHANGE PASSWORD
    case usersTypes.change_password.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case usersTypes.change_password.success: {
      toast({
        html: "Password updated successfully"
      })
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        random: Math.random() // to close password inline form
      }
    }

    case usersTypes.change_password.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CREATE
    case usersTypes.create.init: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case usersTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case usersTypes.create.success: {
      toast({
        html: "User created successfully"
      })
      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        items: action.payload.users,
        pagination: action.payload.pagination,
        errors: []
      }
    }

    case usersTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }



    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/usersReducer.js